import React, { Component } from "react";
import {Link} from 'react-router-dom';
import moment from 'moment'
import { isSimilarObject } from "../../../helper";

export default class TransactionHistory extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const { transactions } = this.props;
        const { data, isFetching } = transactions;

        return(
            <div className="operations-history">
                <h3>История операций</h3>
                <ul className="items-list operations-history-list">
                {
                    isFetching ?
                    <li className="list-item">Загружается...</li>
                    :
                        data.results.length ? data.results.map((item, index) =>
                            <li key={index} className="list-item">
                                {
                                    item.order_id
                                    ? <Link to={`/makeorder/${item.order_id}`} className="name">{item.title}</Link>
                                    : <div className="name">{item.title}</div>
                                }
                                <div className="date">{moment(item.created_at).format('DD.MM.YYYY, HH:mm:ss')}</div>
                                <div className={item.change_balance < 0 ? "balance-change text_red" : "balance-change text_green"}>{item.change_balance} р.</div>
                            </li>
                        )
                        : <li className="list-item">Операций нет</li>
                }
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Account/Balance/TransactionHistory.js